import { ErrorHandler, Injectable, inject } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class AnalyticsErrorHandler implements ErrorHandler {
    private readonly analytics = inject(AnalyticsService);

    handleError(error: unknown): void {
        try {
            const err = error instanceof Error ? error : new Error(String(error));
            const stackTop = err.stack?.split('\n')[1]?.trim();
            this.analytics.track('exception', {
                description: (err.message || 'unknown').slice(0, 150),
                fatal: false,
                stack_top: stackTop ? stackTop.slice(0, 150) : undefined
            });
        } catch {
            // Nunca suprimir o erro original por falha no tracking.
        }
        // Preserva o comportamento padrão: loga no console.
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
